/**
 * Duck
 * @author Gabriel de Oliveira Rigo
 * @copyright 12/2019
 */

import { createActions, createReducer } from "reduxsauce"

 //Action types e Creators
export const { Types, Creators } = createActions({
    itemList: ['items'],
    itemListBox: ['itemListBox'],
    itemClean: ['']
});

//Reucer Handlers
const INITIAL_STATE = {
    items: [],
    itemsBox: []
};

const itemList = (state = INITIAL_STATE, action) => {
    return { ...state, items: action.payload }
}

const itemListBox = (state = INITIAL_STATE, action) => {
    return { ...state, itemsBox: action.payload }
}

const clean = (state = INITIAL_STATE) =>
    INITIAL_STATE

//Criando Reducer
export default createReducer(INITIAL_STATE, {
    [Types.ITEM_LIST]: itemList,
    [Types.ITEM_LIST_BOX]: itemListBox,
    [Types.ITEM_CLEAN]: clean
});